// Port of api/fuel/packages/stream/classes/session.php
// Offline session stub - provides get/set for session values.

var _data = {}

export default {
	get: function(key, def) {
		var val = _data[key]
		return val !== undefined ? val : (def !== undefined ? def : null)
	},
	set: function(key, value) {
		_data[key] = value
	},
	clear: function() {
		_data = {}
	}
}
